module.exports = __webpack_public_path__ + "static/media/img_resume@2x.3eb22107.png";